import { render, staticRenderFns } from "./GraficoGrid.vue?vue&type=template&id=6842058c&"
import script from "./GraficoGrid.vue?vue&type=script&lang=ts&"
export * from "./GraficoGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6842058c', component.options)
    } else {
      api.reload('6842058c', component.options)
    }
    module.hot.accept("./GraficoGrid.vue?vue&type=template&id=6842058c&", function () {
      api.rerender('6842058c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboardEsmax/TiposGraficos/GraficoGrid.vue"
export default component.exports